export const formatResponse = async (response) => {  
    const data = await response.json();
    let newResponse
    if(response?.ok){
        newResponse = {
            'headers': response?.headers,
            'statusCode': response?.status,
            'data': data,
            'error': null
        }  
        return newResponse
    }else{  
        return newResponse = {
            'headers': response?.headers,
            'statusCode': response?.status,
            'data': null,
            'error': ''
        }
    }
}

export const formatResponseClasic = async (response) => {  
    const data = await response.json();
    return data
}